import { useEffect } from 'react';

import { useTeamsClientSetupNext } from '../../../teams-wrapper/hooks/use-teams-client-setup';
import { useSetTeamsConfigActions } from '../../store/main';
import { type TeamsClientConfig } from '../../types';

export const useSetClientConfig = (clientConfig: TeamsClientConfig) => {
	const { setClientConfig } = useSetTeamsConfigActions();

	useTeamsClientSetupNext({
		stargateRoot: clientConfig.stargateRoot,
		cloudId: clientConfig.cloudId,
		orgId: clientConfig.orgId,
		principalUserId: clientConfig.principalUserId,
	});

	useEffect(() => {
		setClientConfig(clientConfig);
	}, [setClientConfig, clientConfig]);
};
